<template>
    <div class="pop-up" >
        <div class="content" :style="{width:width}">
            <div class="header">
                <span>{{headTitle}}</span>
                <i class="el-icon-close" @click="$emit('close')"></i>
            </div>
            <div class="center">
                <slot name="content"></slot>
            </div>
            <div class="footer">
                <div class="btn_solid btn" @click="$emit('confirm')">确定</div>
                <div class="btn_hollow btn" @click="$emit('cancel'),$emit('close')">取消</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'popUp',
    props:{
        headTitle:{},
        width:{
            default:'681px'
        }
    },
    data() {
        return {
            
        }
    },

    created() {
        
    },

    mounted() {
        
    },

    methods: {

    },
}
</script>

<style lang='scss' scoped>
    .pop-up{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background-color: rgba(0,0,0,.2);
        z-index: 1;
    }
    .content{
        // width: 662px;
        height: auto;
        background-color: #fff;
        position: absolute;
        left:50%;
        top:47%;
        transform: translate(-50%, -50%);
    }
    .header{
        width: 100%;
        height: 45px;
        background-color: #2D518E;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 18px 0 25px;
        color: #fff;
        font-size: 16px;
        i{
            font-size: 18px;
            cursor: pointer;
        }
    }
    .center{
        min-height: 165px;
    }
    .footer{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        height: 72px;
        border-top: 1px solid #F1F1F1;
        padding-right: 30px;
        .btn{
            width: 84px;
            height: 32px;
        }

    }
</style>